import { Dispatch, FC, SetStateAction } from "react";

type SwitchComponentType = {
  id: string;
  value: boolean;
  onChange: Dispatch<SetStateAction<boolean>>;
};

const SwitchComponent: FC<SwitchComponentType> = ({ id, value, onChange }) => {
  return (
    <div className="flex items-center">
      <div className="form-switch">
        <input
          type="checkbox"
          id={id}
          className="sr-only"
          checked={Boolean(value)}
          onChange={(event) => onChange(event.currentTarget.checked)}
        />
        <label className="bg-slate-400" htmlFor={id}>
          <span className="bg-white shadow-xs" aria-hidden="true"></span>
        </label>
      </div>
    </div>
  );
};

export default SwitchComponent;
